module.exports = __webpack_public_path__ + "img/Uebersicht_Ohr_Innen.1040d64f.jpg";